import * as React from 'react';
import { Link } from 'react-router-dom';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CoPresentIcon from '@mui/icons-material/CoPresent';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import YouTubeIcon from '@mui/icons-material/YouTube';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import List from '@mui/material/List';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Store } from '../../../../types';
import useRole from '../../../../hooks/useRole';

const linkStyles = {
  color: 'inherit',
  textDecoration: 'inherit',
};

const pageConfig = [
  {
    index: 0,
    path: '/dashboard/news',
    icon: <NewspaperIcon />,
    title: 'dashboard.news',
    pageName: 'PAGE_NEWS',
  },
  {
    index: 1,
    path: '/dashboard/courses',
    icon: <ShoppingCartIcon />,
    title: 'dashboard.courses',
    pageName: 'PAGE_COURSES',
  },
  {
    index: 4,
    path: '/dashboard/about-patricia',
    icon: <CoPresentIcon />,
    title: 'dashboard.patriciaIntroduction',
    pageName: 'PAGE_PATRICIA_INTRODUCTION',
  },
  {
    index: 5,
    path: '/dashboard/about-hec',
    icon: <AutoGraphIcon />,
    title: 'dashboard.highEnergySecrets',
    pageName: 'PAGE_HIGH_ENERGY_SECRETS',
  },
  {
    index: 2,
    path: '/dashboard/youtube',
    icon: <YouTubeIcon />,
    title: 'dashboard.youtube',
    pageName: 'PAGE_YOUTUBE',
  },
  {
    index: 3,
    path: '/dashboard/notifications',
    icon: <NotificationsIcon />,
    title: 'dashboard.notifications',
    pageName: 'PAGE_NOTIFICATIONS',
  },
  {
    index: 7,
    path: '/dashboard/lifestyle',
    icon: <FavoriteBorderIcon />,
    title: 'dashboard.lifestyle',
    pageName: 'PAGE_LIFESTYLE',
  },
];

type Props = {
  selectedIndex: number;
  setSelectedIndex: (index: number) => void;
  isSuperAdmin: boolean;
};

export const ListItems: React.FC<Props> = ({ selectedIndex, setSelectedIndex, isSuperAdmin }) => {
  const { t } = useTranslation();
  const permissions = useSelector((state: Store) => state.auth.permissions);
  const { isAdmin } = useRole();

  const getPermission = (pageName: string) => {
    const p = permissions.find((p) => p.page === pageName);
    return p || { canRead: false, canEdit: false };
  };

  return (
    <List style={{ flexGrow: 1 }}>
      {pageConfig.map(({ index, path, icon, title, pageName }) => {
        if (isAdmin) {
          const { canRead, canEdit } = getPermission(pageName);
          if (!canRead && !canEdit) return null;
        }

        const isDisabled = isAdmin && !getPermission(pageName).canEdit;

        return (
          <Link
            key={path}
            to={path}
            style={{
              ...linkStyles,
              opacity: isDisabled ? 0.7 : 1,
            }}>
            <ListItem
              onClick={() => {
                setSelectedIndex(index);
              }}
              selected={selectedIndex === index}
              button>
              <ListItemIcon sx={{ minWidth: 55 }}>{icon}</ListItemIcon>
              <ListItemText primary={t(title)} />
            </ListItem>
          </Link>
        );
      })}

      {isSuperAdmin && (
        <Link to="/dashboard/user-management" style={linkStyles}>
          <ListItem
            onClick={() => {
              setSelectedIndex(6);
            }}
            selected={selectedIndex === 6}
            button>
            <ListItemIcon>
              <AccountCircleIcon />
            </ListItemIcon>
            <ListItemText primary={t('dashboard.users')} />
          </ListItem>
        </Link>
      )}
    </List>
  );
};
